export default __webpack_public_path__ + "static/media/step3.a32759d2.mp4";